import { render } from "./ConsultaAvancadaPage.vue?vue&type=template&id=a85d3708"
import script from "./ConsultaAvancadaPage.vue?vue&type=script&lang=js"
export * from "./ConsultaAvancadaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__